import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import reportWebVitals from 'reportWebVitals';

import App from 'components/App';

import ScrollToTop from "components/router/ScrollToTop";

/*Import Files Redux*/
import {Provider} from "react-redux";
import configureStore from "redux/store";
import {PersistGate} from 'redux-persist/integration/react';

/*Import React Router Dom*/
import {BrowserRouter as Router} from "react-router-dom";

/*Import Styles*/
import 'styles/css/app.scss';

const {store, persistor} = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router >
                <ScrollToTop/>
                <App/>
            </Router>
        </PersistGate>
    </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
